import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import PropertiesS1 from "../components/properties/PropertiesS1";
// import PropertiesS3 from "../components/properties/PropertiesS3";

const Properties = () => {
  return (
    <div>
      <Navbar />
      <PropertiesS1 />
      <Footer />
      
    </div>
  );
};

export default Properties;
